var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisszaGomb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147 155",
    style: {
      enableBackground: "new 0 0 147 155"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A3AF16;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.96,103.52l82.91,47.87c19.93,11.51,44.84-2.88,44.84-25.89V29.75c0-23.01-24.91-37.4-44.84-25.89 L14.96,51.73C-4.97,63.24-4.97,92.01,14.96,103.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.73,64.75l4.86,13.9c0.82,2.25,1.48,4.29,1.99,6.34h0.15c0.56-2.04,1.28-4.09,2.1-6.34l4.8-13.9h4.7 L31.63,89.5h-4.29l-9.41-24.74H22.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.57,57.8c0.05,1.53-1.07,2.76-2.86,2.76c-1.58,0-2.71-1.23-2.71-2.76c0-1.58,1.18-2.81,2.81-2.81 C48.5,54.99,49.57,56.22,49.57,57.8z M44.56,89.5V64.75h4.5V89.5H44.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.88,84.89c1.33,0.87,3.68,1.79,5.93,1.79c3.27,0,4.8-1.64,4.8-3.68c0-2.15-1.28-3.32-4.6-4.55 c-4.45-1.58-6.54-4.04-6.54-7c0-3.99,3.22-7.26,8.54-7.26c2.5,0,4.7,0.72,6.08,1.53L67.97,69c-0.97-0.61-2.76-1.43-5.06-1.43 c-2.66,0-4.14,1.53-4.14,3.37c0,2.04,1.48,2.96,4.7,4.19c4.29,1.64,6.49,3.78,6.49,7.46c0,4.35-3.37,7.41-9.25,7.41 c-2.71,0-5.21-0.66-6.95-1.69L54.88,84.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.1,84.89c1.33,0.87,3.68,1.79,5.93,1.79c3.27,0,4.8-1.64,4.8-3.68c0-2.15-1.28-3.32-4.6-4.55 c-4.45-1.58-6.54-4.04-6.54-7c0-3.99,3.22-7.26,8.54-7.26c2.5,0,4.7,0.72,6.08,1.53L87.19,69c-0.97-0.61-2.76-1.43-5.06-1.43 c-2.66,0-4.14,1.53-4.14,3.37c0,2.04,1.48,2.96,4.7,4.19c4.29,1.64,6.49,3.78,6.49,7.46c0,4.35-3.37,7.41-9.25,7.41 c-2.71,0-5.21-0.66-6.95-1.69L74.1,84.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.13,86.89l11.19-14.57c1.07-1.33,2.1-2.5,3.22-3.83v-0.1H92.15v-3.63h18.86l-0.05,2.81L99.92,81.93 c-1.02,1.38-2.04,2.61-3.17,3.88v0.1h14.47v3.58H91.13V86.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.49,89.5l-0.36-3.12h-0.15c-1.38,1.94-4.04,3.68-7.57,3.68c-5.01,0-7.57-3.53-7.57-7.11 c0-5.98,5.32-9.25,14.88-9.2v-0.51c0-2.04-0.56-5.73-5.62-5.73c-2.3,0-4.7,0.72-6.44,1.84l-1.02-2.96c2.04-1.33,5.01-2.2,8.13-2.2 c7.57,0,9.41,5.16,9.41,10.12v9.25c0,2.15,0.1,4.24,0.41,5.93H128.49z M127.83,76.87c-4.91-0.1-10.48,0.77-10.48,5.57 c0,2.91,1.94,4.29,4.24,4.29c3.22,0,5.26-2.04,5.98-4.14c0.15-0.46,0.26-0.97,0.26-1.43V76.87z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisszaGomb);
export default __webpack_public_path__ + "static/media/vissza_gomb.ce9e88cc6a4f64b423ea2c5133519ae0.svg";
export { ForwardRef as ReactComponent };